import { useQuery } from "@tanstack/react-query";
import { getProject } from "../api";
import { reactQueryCacheAndRefetchOptions } from "@";
import { projectsKeys } from "./keys";
import type { Project } from "../../types";

// Query hook for fetching a single project
export const useProjectQuery = (id: number | string | undefined) => {
  return useQuery<Project>({
    queryKey: projectsKeys.detail(id),
    queryFn: async () => {
      const { data } = await getProject(id!);
      return data;
    },
    enabled: !!id,
    ...reactQueryCacheAndRefetchOptions,
  });
};
